






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CandleInfo extends Vue {
  
  @Prop({ default: "fab" })
  type?: string;

  @Prop({ default: "font-awesome" })
  icon?: string;

  @Prop({ default: "#" })
  href?: string;
  
}
